import "jquery-ui/ui/widgets/tooltip";
import moment from "moment";

ko.bindingHandlers.fadeVisible = {
	init: function(element, valueAccessor) {
		var value = ko.utils.unwrapObservable(valueAccessor());
		$(element).toggle(value);
	},
	update: function(element, valueAccessor) {
		var value = ko.utils.unwrapObservable(valueAccessor());
		value ? $(element).stop().fadeIn() : $(element).stop().fadeOut();
	}
};

ko.bindingHandlers.dateCountdown = {
	init: function(element, valueAccessor) {
		var self = this;
		var value = ko.utils.unwrapObservable(valueAccessor());
		value = value instanceof Date ? parseInt(value.getTime() / 1000) : value;
		$(element).data('value', value);

		var timer = setInterval(function() {
			$(element).text(getHumanDuration($(element).data('value') - parseInt(Date.now() / 1000), true));
		}, 1000);
	},
	update: function (element, valueAccessor) {
		var self = this;
		var value = ko.utils.unwrapObservable(valueAccessor());
		value = value instanceof Date ? parseInt(value.getTime() / 1000) : value;
		$(element).data('value', value);
	}
};

ko.bindingHandlers.customSelect = {
	init: function(element, valueAccessor/*, allBindings, viewModel, bindingContext*/) {
		var parameters = valueAccessor();
		var optionsText = parameters['optionsText'];
		var value = parameters['value'];
		var options = parameters['options'];
		var color = parameters['color'];
		var caption = parameters['caption'];

		var valueElement = $('<div>').appendTo(element);
		/*var optionsElement =*/ $('<ul>').appendTo(element);
		valueElement.on('click', function() {
			$(element).toggleClass('active');
		});
		if(ko.isObservable(value)) {
			value.subscribe(function() {
				updateValueElement();
			});
		}

		if(!caption && ko.isObservable(value)) {
			value(ko.utils.unwrapObservable(options)[0]);
		}
		updateValueElement();

		function updateValueElement() {
			var _value = ko.utils.unwrapObservable(value);
			var _text = _value ? ko.utils.unwrapObservable(optionsText ? _value[optionsText] : _value) : caption;
			var _color = _value ? ko.utils.unwrapObservable(_value[color] ? _value[color] : null) : null;
			valueElement.text(_text);
			if(color) {
				valueElement.css({backgroundColor: _color ? '#' + _color : ''});
			}
		}
	},
	update: function(element, valueAccessor/*, allBindings, viewModel, bindingContext*/) {
		var parameters = valueAccessor();
		var optionsText = parameters['optionsText'];
		var value = parameters['value'];
		var options = parameters['options'];
		var color = parameters['color'];
		var caption = parameters['caption'];

		var optionsElement = $(element).find('ul');

		if(!options) {
			throw new Error('KO.customSelect: options required');
		}
		if(!value) {
			throw new Error('KO.customSelect: value required');
		}

		optionsElement.children().remove();
		if(caption) {
			$('<li>').appendTo(optionsElement)
				.on('click', function() { value(null); $(element).removeClass('active'); })
				.append($('<span>').text(caption))
		}
		ko.utils.unwrapObservable(options).forEach(function(option) {
			var optionElement = $('<li>').appendTo(optionsElement)
				.on('click', function() {
					if(ko.isObservable(value)) {
						value(option);
						$(element).removeClass('active');
					}
				})
				;
			if(color) {
				$('<span>').appendTo(optionElement).addClass('color')
					.css({backgroundColor: '#' + ko.utils.unwrapObservable(option[color] ? option[color] : '')})
				;
			}
			$('<span>').appendTo(optionElement)
				.text(ko.utils.unwrapObservable(optionsText ? option[optionsText] : option))
			;
		});
	}
};

ko.bindingHandlers.inputMultiLanguage = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();

		var languages = ko.observableArray([]);
		var language = ko.observable();

		$.each(value, function(lang, value) {
			if(lang.length && lang.length == 2) {
				languages.push(lang);
				value.subscribe(function(value) {
					if(lang == language()) {
						$(element).val(value);
					}
				});
			}
		});

		var languageSelect = $('<select>').insertBefore($(element))
			.change(function() { language($(this).val()); })
			;
		languages().forEach(function(_language) {
			$('<option>').appendTo(languageSelect)
				.text(_language.toUpperCase())
				.val(_language)
				.attr('selected', _language == language())
			;
		});
		language.subscribe(function(language) {
			$(element)
				.val(ko.utils.unwrapObservable(value[language]))
			;
		});

		$(element).on('change', function() {
			value[language()]($(this).val());
		});

		languageSelect.val(languages()[0]).change();
	}
};

ko.bindingHandlers.multiInput = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();

		var inputs = ko.observableArray([]);
		var input = ko.observable();

		$.each(value, function(key, value) {
			inputs.push(key);
			value.subscribe(function(value) {
				if(key == input()) {
					$(element).val(value);
				}
			});
		});

		$(element).parent().addClass('ko-multiInput');

		var inputSelect = $('<select>').insertBefore($(element))
			.change(function() { input($(this).val()); })
			;
		inputs().forEach(function(_input) {
			$('<option>').appendTo(inputSelect)
				.text(_input.toUpperCase())
				.val(_input)
				.attr('selected', _input == input())
			;
		});
		input.subscribe(function(key) {
			$(element)
				.val(ko.utils.unwrapObservable(value[key]))
			;
		});

		$(element).on('change', function() {
			value[input()]($(this).val());
		});

		inputSelect.val(inputs()[0]).change();
	}
};

ko.bindingHandlers.datePicker = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();
		var date = ko.utils.unwrapObservable(value);
		var isDate = (date instanceof Date);
		date = isDate ? date : new Date(date * 1000);
		$(element)
			.val(moment(date).format('d.m.Y'))
			.datepicker()
			.on('change', function() {
				if(ko.isObservable(value)) {
					var date = $(this).val().split('.');
					date = new Date(
						date[2], date[1]-1, date[0],
						value().getHours(), value().getMinutes(), value().getSeconds()
					);
					value(isDate ? date : parseInt(date.getTime() / 1000));
				}
			})
		;
	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();
		var date = ko.utils.unwrapObservable(value);
		date = (date instanceof Date) ? date : new Date(date * 1000);
		$(element).val(moment(date).format('DD.MM.YYYY'));
		//			$(element).datepicker();
	}
};
ko.bindingHandlers.timePicker = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();
		var date = ko.utils.unwrapObservable(value);
		var isDate = (date instanceof Date);
		date = isDate ? date : new Date(date * 1000);

		$(element)
			.val(moment(date).format('HH:mm:ss'))
			.on('change', function() {
				if(ko.observable(value)) {
					var time = $(this).val().split(':');
					var date = new Date(
						value().getFullYear(), value().getMonth(), value().getDate(),
						time[0], time[1], time[2]
					);
					value(isDate ? date : parseInt(date.getTime() / 1000));
				}
			})
			.on('keydown', function(event) {
				function updateTime(increment) {
					var position = element.selectionStart;

					var time = $(element).val().split(':');
					var date = new Date(
						value().getFullYear(), value().getMonth(), value().getDate(),
						time[0], time[1], time[2]
					);

					if(position <= 2) {
						increment *= 3600;
					} else if(position <= 5) {
						increment *= 60;
					}
					date.setTime(date.getTime() + increment*1000);

					$(element).val(moment(date).format('HH:mm:ss'));
					element.selectionEnd = element.selectionStart = position;
					event.preventDefault();
					event.stopPropagation();
				}
				switch(event.which) {
					case 38: // UP
						updateTime(1);
						break;
					case 40: // DOWN
						updateTime(-1);
						break;
				}
			})
		;

	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();
		var date = ko.utils.unwrapObservable(value);
		date = (date instanceof Date) ? date : new Date(date * 1000);
		$(element).val(moment(date).format('HH:mm:ss'));
	}
};

ko.bindingHandlers.colorPicker = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();
		$(element)
			.addClass('ko-colorPicker')
			.colpick({
				color: ko.utils.unwrapObservable(value) || 'FFFFFF',
				onSubmit: function(hsb, hex, rgb) {
					$(element).css({backgroundColor: '#' + hex});
					if(ko.isObservable(value)) {
						value(hex);
					}
				}
			})
		;
	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var value = valueAccessor();
		$(element).css({backgroundColor: '#' + ko.utils.unwrapObservable(value)});
	}
};

ko.bindingHandlers.tooltip = {
	init: function(element, valueAccessor) {
		var local = ko.utils.unwrapObservable(valueAccessor()),
			options = {};

		ko.utils.extend(options, ko.bindingHandlers.tooltip.options);
		ko.utils.extend(options, local);

		options.content  =
			(options.photo ? "<picture><img src=\""+options.photo+"\" onerror=\"$(this).parent().remove()\"></picture>" : '') +
			"<main><h2>"+options.fullname+"</h2><p>"+options.description+"</p></main>" +
			'<div style=\'clear: both;\'></div>'
		;

		if(options.photo || options.description) {
			$(element).tooltip(options);

			ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
				$(element).tooltip("destroy");
			});
		}
	},
	options: {
		placement: "right",
		trigger: "click"
	}
};

//ko.bindingHandlers.countdown = {
//	init: function(element, valueAccessor) {
//		var value = ko.utils.unwrapObservable(valueAccessor());
//		$(element).text(getHumanDuration(value));
//	},
//	update: function (element, valueAccessor) {
//		var self = this;
//		var value = ko.utils.unwrapObservable(valueAccessor());
//		self.timer = setInterval(function() {
//			$(element).text(getHumanDuration(--value));
//			if (value == 0) {
//				clearInterval(self.timer);
//			}
//		}, 1000);
//	}
//};
